import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import { SxProps, Theme, Tooltip } from '@mui/material';

interface Props {
  readonly visible: boolean;
  readonly type: 'lumber' | 'plate' | 'hanger';

  readonly sx?: SxProps<Theme>;
}

export function DefaultListIcon(props: Props) {
  if (!props.visible) return null;

  return (
    <Tooltip disableInteractive title={`This is your organization's default ${props.type} list.`} placement="top">
      <StarIcon color="secondary" fontSize="inherit" sx={props.sx} />
    </Tooltip>
  );
}
